export const INITIAL_INTEGRATION_STATE = {
	inventoryId: "",
	productCode: "",
	productName: "",
	integrationName: "",
	companyName: "",
	agroinventarioResponseMessage: "",
	integrationResponseMessage: "",
	bodySend: "",
	usedExport: false,
	externalCodes: [],
	selectedCode: "",
	productionBatch: "",
	expirationDate: "",
	requiresBatch: 0,
};

export const mapApiResponseToState = (apiData) => ({
	inventoryId: apiData.inventories || "",
	productCode: apiData.product_code || apiData.code || "",
	productName: apiData.tradename || "",
	integrationName: apiData.name || "",
	companyName: apiData.business_name || "",
	agroinventarioResponseMessage: apiData.message || "",
	integrationResponseMessage: apiData.message_response || "",
	bodySend: apiData.body_send || "",
	usedExport: apiData.export_used || false,
	externalCodes: apiData.codes ? apiData.codes.split(",").filter(Boolean) : [],
	selectedCode: apiData.custom || "",
	productionBatch: apiData.lot_production || "",
	expirationDate: apiData.expiration_date || "",
	requiresBatch: apiData.custom_lot ?? 0,
});

export const mapStateToApiPayload = (state, { code, integrationId, balanceId }) => ({
	code,
	integration_id: integrationId,
	balance_id: balanceId,
	external_code: state.externalCodes.join(","),
	custom_option: state.selectedCode,
	production_batch: state.productionBatch,
	expiration_date: state.expirationDate,
	inventory_id: state.inventoryId,
	requires_batch: state.requiresBatch,
});

export const mapSyncResponseToState = (response) => {
	const responseIntegration = response?.integrations?.[0] || response?.response_consume?.integration_queue;

	if (!responseIntegration) {
		return null;
	}

	return mapApiResponseToState(responseIntegration);
};
